/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import { hashHistory } from 'react-router';
import moment from 'moment';
import {showSpin,hideSpin} from 'Utils';
import { Form, Input, Select, TreeSelect, DatePicker, message, Button, Row, Col, InputNumber } from 'antd';
import { DmsTab, RegionCascader } from 'Components';
import { insertByPc, modifyByPc, detail } from '../../service/store';
import { sKeylist } from '../../service/dictionary/dataitem';
import { allChildren } from '../../service/zone';
import { peopleList as employee } from '../../service/people';
import { getListSelect } from '../../service/channel';
import { nameValidator, checkTel, checkPhone, checkInteger } from '../../utils/regexp.js';
const FormItem = Form.Item;

class StoreAdd extends React.Component {
  constructor (props) {
    super(props);
    const belongDealer = this.props.location.query.belongDealer ? parseInt(this.props.location.query.belongDealer, 10) : '';
    this.belongDealer = belongDealer;
    this.state = {
      needDealer: belongDealer ? true : false,
      storeId: parseInt(this.props.params.storeId, 10),
      employee: [],
      channels: [],
      store_type: [],
      store_way: [],
      options: [],
      detail: {},
    }
  }

  componentWillMount () { //准备数据
    const self = this;
    allChildren({ id: 0 }).then(res => { //门店归属区域
      if (res.data && res.data.length > 0) {
        let timer = window.setInterval(function () {
          if (self.mounted) {
            window.clearInterval(timer);
            self.setState({ options: res.data });
          }
        }, 200);
      }
    });
    sKeylist({ sKey: 'store_way' }).then(res => { //门店运营方式
      let timer = window.setInterval(function () {
        if (self.mounted) {
          window.clearInterval(timer);
          self.setState({ store_way: res.data })
        }
      }, 200);
    })
    sKeylist({ sKey: 'store_type' }).then(res => { //门店类型
      let timer = window.setInterval(function () {
        if (self.mounted) {
          window.clearInterval(timer);
          self.setState({ store_type: res.data })
        }
      }, 200);
    })
    employee({ status: 1 }).then(res => { //所属业务员
      let timer = window.setInterval(function () {
        if (self.mounted) {
          window.clearInterval(timer);
          self.setState({ employee: res.data || [] })
        }
      }, 200);
    })
    getListSelect().then(res => { //所属经销商
      let timer = window.setInterval(function () {
        if (self.mounted) {
          window.clearInterval(timer);
          self.setState({ channels: res.data || [] })
        }
      }, 200);
    })
  }

  componentDidMount () {
    this.mounted = true;

    const self = this;
    if (this.state.storeId > 0) {
      detail(self.state.storeId).then(res => {
        self.setState({
          ...this.state,
          needDealer: !!res.data.dmsStore.belongDealer,
          detail: res.data.dmsStore
        })
      })
    }
  }

  cancelHandle () {
    hashHistory.goBack()
  }

  submitHandle () {
    const self = this;
    const { validateFields, getFieldsValue } = this.props.form;

    validateFields((errors) => {//表单校验
      if (errors) {
        return
      }//表单校验有误，则不执行下面的代码
      const data = {
        ...getFieldsValue() //获取用户输入
      };
      const result = {
        ...data,
        ...data.adminDiv.value,
      }
      delete result.adminDiv; //删除冗余数据
      // console.log(`你正在提交数据：${JSON.stringify(result)}`);

      showSpin();
      if (self.state.storeId > 0) {
        modifyByPc({ ...result, id: self.state.storeId }).then(res => {
          hideSpin();
          message[res.status ? 'success' : 'error'](res.message);
          res.status && hashHistory.goBack()
        })
      } else {
        insertByPc(result).then(res => {
          hideSpin();
          message[res.status ? 'success' : 'error'](res.message);
          res.status && hashHistory.goBack()
        })
      }
    })
  }

  render () {
    const self = this;
    const { storeId, store_type, store_way, needDealer, employee, channels } = this.state;
    let { detail } = this.state;
    const { getFieldDecorator } = this.props.form;

    /*this.belongDealer ? detail['belongDealer'] = this.belongDealer : null;*/

    return <div className="dms-body">
      <DmsTab options={[`${storeId ? '编辑门店' : '新增门店'}`]} defaultKey={0}>
        <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
        <Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
      </DmsTab>
      <div className="dms-table-box">
        <Form layout="horizontal">
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="门店名称：" hasFeedback>
                {getFieldDecorator('name', {
                  initialValue: detail.name || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入门店名称'
                    },
                    {
                      validator: nameValidator
                    }
                  ],
                })(<Input placeholder="请输入门店名称"/>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="门店编码：" hasFeedback>
                {/*{getFieldDecorator('code', {
                 initialValue: detail.code || '',
                 rules: [
                 {
                 required: true,
                 message: '请输入门店编码'
                 },
                 ],
                 })(<Input placeholder="请输入门店编码"/>)}*/}
                <Input disabled={true} value={detail.code || ''} placeholder="门店编码"/>
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <div id="operateWayBox">
                <FormItem label="运营方式：" hasFeedback>
                  {getFieldDecorator('operateWay', {
                    initialValue: storeId ? (detail.operateWay!==null ? detail.operateWay+'' : '') : (this.belongDealer ? '1' : ''),
                    rules: [
                      {
                        required: true,
                        message: '请选择运营方式'
                      },
                    ],
                    getValueFromEvent: (e) => {
                      if (e === '1') {
                        self.setState({ needDealer: true });
                      } else {
                        self.setState({ needDealer: false });
                      }
                      return e
                    }
                  })(<Select
                    allowClear
                    disabled={ storeId>0? true : !!this.belongDealer}
                    style={{ width: '100%' }}
                    getPopupContainer={() => document.getElementById('operateWayBox')}
                    placeholder="请选择运营方式"
                  >
                    {
                      store_way.map((item, index) => {
                        return <Select.Option key={index + ''} value={item.sKey}>{item.name}</Select.Option>
                      })
                    }
                  </Select>)}
                </FormItem>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div id="storeTypeBox">
                <FormItem label="类型：" hasFeedback>
                  {getFieldDecorator('storeType', {
                    initialValue: detail.storeType || '',
                    rules: [
                      {
                        required: true,
                        message: '请选择类型'
                      },
                    ],
                  })(<Select
                    allowClear
                    style={{ width: '100%' }}
                    getPopupContainer={() => document.getElementById('storeTypeBox')}
                    placeholder="请选择类型"
                  >
                    {
                      store_type.map((item, index) => {
                        return <Select.Option key={index + ''} value={item.sKey}>{item.name}</Select.Option>
                      })
                    }
                  </Select>)}
                </FormItem>
              </div>
            </Col>
          </Row>
          {
            !storeId && <Row gutter={16}>
              <Col className="gutter-row" span={12}>
                <FormItem label="店长：" hasFeedback>
                  {getFieldDecorator('shopowner', {
                    initialValue: detail.shopowner || '',
                    rules: [
                      {
                        required: true,
                        message: '请输入店长姓名'
                      },
                      {
                        validator: nameValidator
                      }
                    ],
                  })(<Input/>)}
                </FormItem>
              </Col>
              <Col className="gutter-row" span={12}>
                <FormItem label="店长手机：" hasFeedback>
                  {getFieldDecorator('shopownerPhone', {
                    initialValue: detail.shopownerPhone || '',
                    rules: [
                      {
                        required: true,
                        message: '请输入店长手机'
                      },
                      {
                        validator: checkPhone
                      }
                    ],
                  })(<Input/>)}
                </FormItem>
              </Col>
            </Row>
          }
          <Row gutter={16}>
            <Col className="gutter-row" span={24}>
              <div id="adminDivBox">
                <FormItem label="门店地址：" hasFeedback>
                  {getFieldDecorator('adminDiv', storeId > 0 ? {
                    initialValue: {
                      province: detail.province || '',
                      city: detail.city || '',
                      county: detail.county || '',
                    },
                    rules: [
                      {
                        required: true,
                        message: '请选择门店地址'
                      },
                    ]
                  } : {
                    rules: [
                      {
                        required: true,
                        message: '请选择门店地址'
                      },
                    ]
                  })(<RegionCascader containerId="adminDivBox" placeholder="请选择门店地址" style={{ width: '100%' }}/>)}
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={24}>
              <FormItem label={null} hasFeedback>
                {getFieldDecorator('storeAddress', {
                  initialValue: detail.storeAddress || '',
                  rules: [
                    {
                      required: true,
                      message: '请输入门店详细地址'
                    },
                  ]
                })(<Input placeholder="详细地址" style={{ width: '100%' }}/>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <div id="belongAreaBox">
                <FormItem label="归属区域：" hasFeedback>
                  {getFieldDecorator('belongArea', detail.belongArea ? {
                    initialValue: detail.belongArea.toString(),
                    rules: [
                      {
                        required: true,
                        message: '请输入归属区域'
                      },
                    ],
                  } : {
                    rules: [
                      {
                        required: true,
                        message: '请输入归属区域'
                      },
                    ],
                  })(<TreeSelect
                    size="large"
                    treeDefaultExpandAll
                    dropdownStyle={{maxHeight: '240px', overflow:'auto'}}
                    treeData={this.state.options}
                    getPopupContainer={() => document.getElementById('belongAreaBox')}
                  />)}
                </FormItem>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div id="belongEmployeeBox">
                <FormItem label="所属业务员：" hasFeedback>
                  {getFieldDecorator('belongEmployee', {
                    initialValue: detail.belongEmployee ? detail.belongEmployee + '' : '',
                    rules: [
                      {
                        required: false,
                        message: '请选择所属业务员'
                      },
                    ],
                  })(<Select
                    allowClear
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="请选择所属业务员"
                    dropdownStyle={{maxHeight: '240px', overflow:'auto'}}
                    optionFilterProp="desc"
                    getPopupContainer={() => document.getElementById('belongEmployeeBox')}
                  >
                    {
                      employee.map((item, index) => {
                        return <Select.Option key={index + ''} value={item.id + ''}
                                              desc={item.name}>{item.name}</Select.Option>
                      })
                    }
                  </Select>)}
                </FormItem>
              </div>
            </Col>
          </Row>
          {needDealer && <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <div id="belongDealerBox">
                <FormItem label="所属经销商：" hasFeedback>
                  {getFieldDecorator('belongDealer', {
                    initialValue: detail.belongDealer ? detail.belongDealer + '' : '',
                    rules: [
                      {
                        required: needDealer,
                        message: '请选择所属经销商'
                      },
                    ],
                  })(<Select
                    allowClear
                    showSearch
                    disabled={storeId>0 ? true : !!this.belongDealer}
                    style={{ width: '100%' }}
                    placeholder="请选择所属经销商"
                    optionFilterProp="desc"
                    getPopupContainer={() => document.getElementById('belongDealerBox')}
                  >
                    {
                      channels.map((item, index) => {
                        return <Select.Option key={index + ''} value={item.id + ''}
                                              desc={item.name}>{item.name}</Select.Option>
                      })
                    }
                  </Select>)}
                </FormItem>
              </div>
            </Col>
          </Row>}
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="店面电话：" hasFeedback>
                {getFieldDecorator('storePhone', {
                  initialValue: detail.storePhone || '',
                  rules: [
                    {
                      required: false,
                      message: '请输入店面电话'
                    },
                    {
                      validator: checkTel
                    }
                  ],
                })(<Input/>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="员工总数（人）：" hasFeedback>
                {getFieldDecorator('storeEmployeeNum', {
                  initialValue: detail.storeEmployeeNum || '',
                  rules: [
                    {
                      required: false,
                      message: '请输入员工总数'
                    },
                    {
                      validator: checkInteger
                    }
                  ],
                })(<Input/>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <div id="DatePicker1">
                <FormItem label="开业时间：" hasFeedback>
                  {getFieldDecorator('openDate', {
                    initialValue: detail.openDate ? moment((new Date(detail.openDate)), 'YYYY-MM-DD') : null,
                    rules: [
                      {
                        required: false,
                        message: '请选择开业时间'
                      },
                    ],
                  })(<DatePicker style={{ width: '100%' }}
                                 getCalendarContainer={() => document.getElementById('DatePicker1')}/>)}
                </FormItem>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div id="DatePicker2">
                <FormItem label="关停时间：" hasFeedback>
                  {getFieldDecorator('closeDate', {
                    initialValue: detail.closeDate ? moment((new Date(detail.closeDate)), 'YYYY-MM-DD') : null,
                    rules: [
                      {
                        required: false,
                        message: '请选择关停时间'
                      },
                    ],
                  })(<DatePicker style={{ width: '100%' }}
                                 getCalendarContainer={() => document.getElementById('DatePicker2')}/>)}
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem label="店面面积(m²)：" hasFeedback>
                {getFieldDecorator('storeArea', {
                  initialValue: detail.storeArea || '',
                  rules: [
                    {
                      required: false,
                      message: '请输入店面面积'
                    }
                  ],
                })(<InputNumber min={0} placeholder="请输入店面面积" style={{width: '100%'}}/>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem label="年销售额(万元)：" hasFeedback>
                {getFieldDecorator('sellVolume', {
                  initialValue: detail.sellVolume || '',
                  rules: [
                    {
                      required: false,
                      message: '请输入年销售额'
                    }
                  ],
                })(<InputNumber min={0} placeholder="请输入年销售额" style={{width: '100%'}}/>)}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  }
}
export default Form.create()(StoreAdd)


// WEBPACK FOOTER //
// ./src/routes/store/add.js